export const GAME_DESCRIPTION_MAX_LENGTH = 500;

export function normalizeCreateDescription(value: string): string | undefined {
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
}

export function deriveCreateDescription(value: string): string | undefined {
  const normalized = normalizeCreateDescription(value);
  if (!normalized) return undefined;
  return normalized.length > GAME_DESCRIPTION_MAX_LENGTH
    ? normalized.slice(0, GAME_DESCRIPTION_MAX_LENGTH).trimEnd()
    : normalized;
}
